import {VisuallyHidden} from '@radix-ui/react-visually-hidden';
import React, {Fragment} from 'react';

import useAriaLiveMessage from './useAriaLiveMessage';

const AriaLiveContainer = ({children, alert, visible, constant, ...props}) => {
    const role = alert ? 'alert' : 'status';
    const {content} = useAriaLiveMessage({children, role, isConstant: constant});

    return (
        <Container visible={visible}>
            <div role={role} {...props}>
                {content}
            </div>
        </Container>
    );
};

const Container = ({children, visible}) => {
    return visible ? <>{children}</> : <VisuallyHidden>{children}</VisuallyHidden>;
};

export default AriaLiveContainer;
